import { Box, Flex, Icon, Text, Spinner } from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import { Link as RouterLink } from "@tanstack/react-router";
import { FiList } from "react-icons/fi";

// import type { UserPublic } from "../../client";
import { TablesService } from "../../client";

interface SidebarItemsProps {
  onClose?: () => void;
  isCollapsed?: boolean;
}

const SidebarTables = ({ onClose, isCollapsed = false }: SidebarItemsProps) => {
  // const queryClient = useQueryClient();
  // const currentUser = queryClient.getQueryData<UserPublic>(["currentUser"]);

  const {
    data: tables,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["tablesList"],
    queryFn: () => TablesService.readTables({ skip: 0, limit: 100 }), // Adjust limit as needed
    staleTime: 1000 * 60 * 5, // 5분 동안 캐시 유지
    refetchOnWindowFocus: false, // 윈도우 포커스 시 자동 리페치 비활성화
  });

  if (isLoading) {
    return (
      <Flex justifyContent="center" alignItems="center" p={4}>
        <Spinner size="lg" />
      </Flex>
    );
  }

  if (isError || !tables?.data) {
    return (
      <Flex justifyContent="center" alignItems="center" p={4}>
        <Text color="red.500">Failed to load tables. Please try again.</Text>
      </Flex>
    );
  }

  const tableItems =
    tables?.data
      .slice() // Create a copy of the array to avoid mutating the original data
      // .reverse() //순서
      .map((table) => ({
        icon: FiList,
        title: table.table_name,
        path: `/table/${table.id}`,
      })) || [];

  const listTables = tableItems.map(({ icon, title, path }) => (
    <RouterLink key={title} to={path} onClick={onClose}>
      <Flex
        gap={isCollapsed ? 0 : 4}
        px={4}
        py={2}
        _hover={{ background: "gray.subtle" }}
        alignItems="center"
        fontSize="sm"
        flex={1}
      >
        <Icon as={icon} alignSelf="center" boxSize={6} />
        {!isCollapsed && <Text ml={2}>{title}</Text>}
      </Flex>
    </RouterLink>
  ));

  return (
    <>
      {!isCollapsed && (
        <Text fontSize="md" px={4} py={2} fontWeight="bold" color="gray.600">
          테이블
        </Text>
      )}
      <Box w="100%">{listTables}</Box>
    </>
  );
};

export default SidebarTables;
